import { render, staticRenderFns } from "./deptAdd.vue?vue&type=template&id=0f7561ea"
import script from "./deptAdd.vue?vue&type=script&lang=js"
export * from "./deptAdd.vue?vue&type=script&lang=js"
import style0 from "./deptAdd.vue?vue&type=style&index=0&id=0f7561ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports